import Vue from "vue";
import VueRouter from "vue-router";
import VueNotify from "vue-notifyjs";
import VueNotification from "vue-notification";
import VeeValidate from "vee-validate";
import App from "./App.vue";

// Plugins
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import SideBar from "./components/UIComponents/SidebarPlugin";
import initProgress from "./progressbar";

// router setup
import routes from "./routes/routes";

// library imports
import "./assets/sass/paper-dashboard.scss";
import "./assets/sass/element_variables.scss";

import sidebarLinks from "./sidebarLinks";
import store from "@/store";

import VueModal from "vue-js-modal";
import { Bus } from "@/bus";
import { joinPrivateChannels } from "@/communication";
import "@/communication";
import VueAnime from "vue-animejs";

import lang from "element-ui/lib/locale/lang/de";
import locale from "element-ui/lib/locale";

import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";

if (process.env.NODE_ENV != "development") {
  Sentry.init({
    dsn: Laravel.sentrydsn,
    integrations: [new VueIntegration({ Vue, attachProps: true })],
    environment: "Admin-Panel"
  });
}

// configure language
locale.use(lang);

// plugin setup
Vue.use(VueModal);
Vue.use(Bus);
Vue.use(VueRouter);
Vue.use(GlobalDirectives);
Vue.use(GlobalComponents);
Vue.use(VueNotify);
Vue.use(VueNotification);
Vue.use(SideBar, { sidebarLinks: sidebarLinks });
Vue.use(VeeValidate);
Vue.use(VueAnime);

export const router = new VueRouter({
  mode: "history",
  routes,
  linkActiveClass: "active"
});

initProgress(router);

import Table from "@/components/Table.vue";
Vue.component("v-table", Table);

import V2Table from "@/components/V2Table.vue";
Vue.component("v2-table", V2Table);

import TableFilter from "@/components/TableFilter.vue";
Vue.component("table-filter", TableFilter);

import Button from "@/components/Button.vue";
Vue.component("v-button", Button);

import Resource from "@/components/Resource.vue";
Vue.component("resource", Resource);

import ColLabel from "@/vue-paper-dashboard-pro-2/components/Dashboard/Views/Components/ColLabel.vue";
Vue.component("col-label", ColLabel);

import CustomerMediaUpload from "@/components/CustomerMediaUpload.vue";
Vue.component("customer-media-upload", CustomerMediaUpload);

import CustomerMedia from "@/components/CustomerMedia.vue";
Vue.component("customer-media", CustomerMedia);

import VueSlideUpDown from "vue-slide-up-down";
Vue.component("vue-slide-up-down", VueSlideUpDown);

import vueSlider from "vue-slider-component";
Vue.component("vue-slider", vueSlider);

import Switch from "@/components/Switch.vue";
Vue.component("toggle-switch", Switch);

import UploadModal from "@/components/UploadModal.vue";
Vue.component("upload-modal", UploadModal);

export default new Vue({
  el: "#app",
  render: h => h(App),
  router,
  store
});

if (store.getters["user/auth"]) {
  joinPrivateChannels();
}

router.onReady(() => {
  if (!canAccess(router.currentRoute)) {
    router.replace("/notFound");
  }
});

router.beforeEach((to, from, next) => {
  if (!canAccess(to)) {
    next("/notFound");
  } else {
    next();
  }
});

function canAccess(nextRoute) {
  let route = routes[1].children.find(function(child) {
    let childPath = child.path;
    Object.entries(nextRoute.params).forEach(function(parameter) {
      childPath = child.path.replace(":" + parameter[0], parameter[1]);
    });
    return nextRoute.path == childPath;
  });

  let canAccess = !route || (!route.roles && !route.permissions) ? true : false;
  if (route && route.roles) {
    route.roles.forEach(function(role) {
      if (!canAccess) {
        canAccess = store.getters["user/meHasRole"](role);
      }
    });
  }
  if (route && route.permissions) {
    route.permissions.forEach(function(permission) {
      if (!canAccess) {
        canAccess = store.getters["user/meHasPermissionTo"](permission);
      }
    });
  }
  return canAccess;
}
